import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../../felles/components/filter/filter.component";
import { KpitabellComponent } from "../../felles/components/kpitabell/kpitabell.component";
import { KommunefilterComponent } from "../../felles/components/kommunefilter/kommunefilter.component";
import { QlikService } from "../../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, HjelpetekstComponent } from "@husbanken/designsystem-angular-core";
import { GrafComponent } from "../../felles/components/graf/graf.component";

@Component({
  selector: "stat-app-utleiebolig",
  templateUrl: "./utleiebolig.component.html",
  imports: [FilterComponent, KpitabellComponent, KommunefilterComponent, AccordionComponent, AccordionElementComponent, HjelpetekstComponent, GrafComponent],
})
export class UtleieboligComponent implements OnInit {
  statistikkType = "Tilsagn";
  graferValgt = "soknader";
  valgtFilter: { [key: string]: NxCell[] } = null;
  objectKeys = Object.keys;
  grafIderForSoknad: string[] = [];
  grafIderForBolig: string[] = [];
  grafIderForBelop: string[] = [];
  grafIderForKostnad: string[] = [];
  kpiListe: string[] = [];

  typeTekst = {
    Søknad: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. "],
      boliger: [
        "Antall boliger",
        "Viser hvor mange boliger som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. ",
      ],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
    Tilsagn: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. "],
      boliger: [
        "Antall boliger",
        "Viser hvor mange boliger som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. ",
      ],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
    Utbetaling: {
      soknader: ["Antall saker", "Viser samlet antall saker som har sendt inn søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. "],
      boliger: [
        "Antall boliger",
        "Viser hvor mange boliger som er knyttet til sakene som har sendt inn søknad, fått tilsagn eller fått utbetalt tilskudd i perioden som er valgt. ",
      ],
      belop: ["Beløp", "Viser tilskuddsbeløpet det er søkt om, gitt tilsagn for eller som er utbetalt i perioden som er valgt. "],
    },
  };

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("VirkemiddelKode", "TILSK_UTLEIE", false, true);
    this.qlikService.setFilter("TypeTilstand", "Tilsagn", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Tilskudd til utleieboliger - Husbanken");
    this.grafIderForSoknad = [
      "hvb-ant-saker-pr-fylke",
      "hvb-ant-saker",
      "hvb-ant-saker-pr-tiltak",
      "hvb-ant-saker-pr-søkertype",
      "hvb-ant-saker-pr-hustype",
      "hvb-ant-saker-pr-delmålgruppe",
    ];
    this.grafIderForBolig = [
      "hvb-ant-boliger-pr-fylke",
      "hvb-ant-boliger",
      "hvb-ant-boliger-pr-tiltak",
      "hvb-ant-boliger-pr-søkertype",
      "hvb-ant-boliger-pr-hustype",
      "hvb-ant-boliger-pr-delmålgruppe",
    ];
    this.grafIderForBelop = ["hvb-belop-pr-fylke", "hvb-belop", "hvb-belop-pr-tiltak", "hvb-belop-pr-søkertype", "hvb-belop-pr-hustype", "hvb-belop-pr-delmålgruppe"];
    this.grafIderForKostnad = ["hvb-kostnad-pr-fylke", "hvb-kostnad", "hvb-kostnad-pr-tiltak", "hvb-kostnad-pr-delmålgruppe"];
    this.kpiListe = ["HVB Antall saker", "HVB Antall boliger", "HVB Beløp"];
  }

  public filterTilstand(filter) {
    this.qlikService.setFilter("TypeTilstand", filter, false, true);
    this.statistikkType = filter;
  }

  selectedRadio(event) {
    this.graferValgt = event.target.value;
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }

  hentSelectedRadioLabel(): string {
    return this.typeTekst[this.statistikkType][this.graferValgt][0];
  }
}
